/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import Accordion from 'components/Common/Accordion/Accordion';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import { BtnAdd, BtnConfirm, BtnDelete, BtnSave } from 'components/Common/Button';
import { DataGridMuiClient } from 'components/Common/Table/DataGridMuiClient';
import CheckBoxGroupFormItem from 'components/Common/ElementInForm/CheckBoxGroupItem';
import InputNumberFormItem from 'components/Common/ElementInForm/InputNumberFormItem';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { AlertTitleTh, AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#004290",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));


const SLAManage = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const [sLastAction, setsLastAction] = useState("-")

    //#region  ข้อมูล SLA (ข้อร้องเรียนที่มีนัยสำคัญ)
    const [schema, setschema] = useState({} as any);
    const [IsCheckAlertComplaint1, setIsCheckAlertComplaint1] = useState(false)
    const [DataRowComplaint1, setDataRowComplaint1] = useState([] as any)
    const [IsCalComplaint1, setIsCalComplaint1] = useState(false)

    let ObjSchema = {
        sDay_C1_1: yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: false }),
        sToEmail_C1_1: yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: false }),
        sInputEmail_C1_1: yupFormSchemas.string("อื่นๆ", { required: false }),

        sDay_C2_1: yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: false }),
        sToEmail_C2_1: yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: false }),
        sInputEmail_C2_1: yupFormSchemas.string("อื่นๆ", { required: false }),

        sDay_R_1: yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: false }),
        sToEmail_R_1: yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: false }),
        sInputEmail_R_1: yupFormSchemas.string("อื่นๆ", { required: false }),

        sDay_I_1: yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: false }),
    }

    const schemaR = yup.object().shape(Object.assign(ObjSchema, schema));
    let form = useForm({
        resolver: yupResolver(schemaR),
        mode: 'all',
        shouldFocusError: false,
        criteriaMode: "firstError"
    })

    
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        GetDataPageSLA();
    }, [])

    useEffect(() => {
        if (DataRowComplaint1.length > 0) {
            let nAccu = 0;
            let arrComplaint1 = [];

            DataRowComplaint1.forEach(element => {
                let nDay = element.sDay != null && element.sDay != "" ? parseInt(element.sDay) : 0;
                nAccu += nDay;
                element.nDayAccumulate = nAccu;
                arrComplaint1.push(Object.assign({}, element));
            });

        }
    }, [IsCalComplaint1])

    useEffect(() => {
        
        if (DataRowComplaint1.length > 0) {
            for (let i = 0; i < DataRowComplaint1.length; i++) {
                let Id = DataRowComplaint1[i].nRow;
                schema[`sDay_C1_${Id}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: true });
                schema[`sToEmail_C1_${Id}`] = yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: true });
                schema[`sInputEmail_C1_${Id}`] = yupFormSchemas.string("อื่นๆ", { required: DataRowComplaint1[i].arrToEmail != null && DataRowComplaint1[i].arrToEmail.includes("3") ? true : false });
            }
            setschema(schema);

            setTimeout(() => {
                for (let i = 0; i < DataRowComplaint1.length; i++) {
                    let Id = DataRowComplaint1[i].nRow;
                        form.setValue(`sDay_C1_${Id}`, DataRowComplaint1[i].sDay);
                        form.setValue(`sToEmail_C1_${Id}`, DataRowComplaint1[i].arrToEmail);
                        form.setValue(`sInputEmail_C1_${Id}`, DataRowComplaint1[i].sInputToEmail);
                    }
                
            }, 5)
        }
    }, [DataRowComplaint1])
    //#endregion

    //#region  ข้อมูล SLA (ข้อร้องเรียนปกติ)
    const [IsCheckAlertComplaint2, setIsCheckAlertComplaint2] = useState(false)
    const [DataRowComplaint2, setDataRowComplaint2] = useState([] as any)
    const [IsCalComplaint2, setIsCalComplaint2] = useState(false)

    useEffect(() => {
        if (DataRowComplaint2.length > 0) {
            let nAccu = 0;
            let arrComplaint2 = [];

            DataRowComplaint2.forEach(element => {
                let nDay = element.sDay != null && element.sDay != "" ? parseInt(element.sDay) : 0;
                nAccu += nDay;
                element.nDayAccumulate = nAccu;
                arrComplaint2.push(Object.assign({}, element));
            });
        }
    }, [IsCalComplaint2])

     useEffect(() => {
        
        if (DataRowComplaint2.length > 0) {
            for (let i = 0; i < DataRowComplaint2.length; i++) {
                let Id = DataRowComplaint2[i].nRow;
                schema[`sDay_C2_${Id}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: true });
                schema[`sToEmail_C2_${Id}`] = yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: true });
                schema[`sInputEmail_C2_${Id}`] = yupFormSchemas.string("อื่นๆ", { required: DataRowComplaint2[i].arrToEmail != null && DataRowComplaint2[i].arrToEmail.includes("3") ? true : false});
            }
            setschema(schema);

            setTimeout(() => {
                for (let i = 0; i < DataRowComplaint2.length; i++) {
                    let Id = DataRowComplaint2[i].nRow;
                        form.setValue(`sDay_C2_${Id}`, DataRowComplaint2[i].sDay);
                        form.setValue(`sToEmail_C2_${Id}`, DataRowComplaint2[i].arrToEmail);
                        form.setValue(`sInputEmail_C2_${Id}`, DataRowComplaint2[i].sInputToEmail);
                    }
                
            }, 5)
        }
    }, [DataRowComplaint2])
    //#endregion

    //#region  ข้อมูล SLA (ข้อร้องขอ)
    const [IsCheckAlertRequest, setIsCheckAlertRequest] = useState(false)
    const [DataRowRequest, setDataRowRequest] = useState([] as any)
    const [IsCalRequest, setIsCalRequest] = useState(false)

    useEffect(() => {
        if (DataRowRequest.length > 0) {
            let nAccu = 0;
            let arrRequest = [];

            DataRowRequest.forEach(element => {
                let nDay = element.sDay != null && element.sDay != "" ? parseInt(element.sDay) : 0;
                nAccu += nDay;
                element.nDayAccumulate = nAccu;
                arrRequest.push(Object.assign({}, element));
            });
        }
    }, [IsCalRequest])

     useEffect(() => {
        if (DataRowRequest.length > 0) {
            for (let i = 0; i < DataRowRequest.length; i++) {
                let Id = DataRowRequest[i].nRow;
                schema[`sDay_R_${Id}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: true });
                schema[`sToEmail_R_${Id}`] = yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: true });
                schema[`sInputEmail_R_${Id}`] = yupFormSchemas.string("อื่นๆ", { required: DataRowRequest[i].arrToEmail != null && DataRowRequest[i].arrToEmail.includes("3") ? true : false});
            }
            setschema(schema);

            setTimeout(() => {
                for (let i = 0; i < DataRowRequest.length; i++) {
                    let Id = DataRowRequest[i].nRow;
                        form.setValue(`sDay_R_${Id}`, DataRowRequest[i].sDay);
                        form.setValue(`sToEmail_R_${Id}`, DataRowRequest[i].arrToEmail);
                        form.setValue(`sInputEmail_R_${Id}`, DataRowRequest[i].sInputToEmail);
                    }
                
            }, 5)
        }
    }, [DataRowRequest])
    //#endregion

    //#region  ข้อมูล SLA (แจ้งความก้าวหน้า)
    const [IsCheckAlertInform, setIsCheckAlertInform] = useState(false)
    const [DataRowInform, setDataRowInform] = useState([] as any)
    const [IsCalProgress, setIsCalProgress] = useState(false)

    useEffect(() => {
        if (DataRowInform.length > 0) {
            let nAccu = 0;
            let arrProgress = [];

            DataRowInform.forEach(element => {
                let nDay = element.sDay != null && element.sDay != "" ? parseInt(element.sDay) : 0;
                nAccu += nDay;
                element.nDayAccumulate = nAccu;
                arrProgress.push(Object.assign({}, element));
            });
        }
    }, [IsCalProgress])

    useEffect(() => {
        if (DataRowInform.length > 0) {
            for (let i = 0; i < DataRowInform.length; i++) {
                let Id = DataRowInform[i].nRow;
                schema[`sDay_I_${Id}`] = yupFormSchemas.string("จำนวนน้อยที่สุด 1 วัน", { required: true });
            }
            setschema(schema);

            setTimeout(() => {
                for (let i = 0; i < DataRowInform.length; i++) {
                    let Id = DataRowInform[i].nRow;
                        form.setValue(`sDay_I_${Id}`, DataRowInform[i].sDay);
                    }
                
            }, 5)
        }
    }, [DataRowInform])
    //#endregion

    //#region  ข้อมูล SLA (ข้อร้องเรียนที่มีนัยสำคัญ)

    const onAddSLAComplaint1 = () => {
        let dataForm = form.getValues();
        let arrComplaint1 = [];
        (DataRowComplaint1 || []).forEach(val => arrComplaint1.push(Object.assign({}, val)));
        let Id = arrComplaint1.length > 0 ? (Math.max.apply(Math, arrComplaint1.map(function (o) { return o.nRow; }))) + 1 : 1

        arrComplaint1.push({
            nID: Id,
            nRow: Id,
            sDay: null,
            nDayAccumulate: null,
            arrToEmail: [],
            sInputToEmail: null,
            isDelete: false,
            isNew: true,
        })

        setDataRowComplaint1(arrComplaint1)
        schema[`sDay_C1_${Id}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: true });
        schema[`sToEmail_C1_${Id}`] = yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: true });
        schema[`sInputEmail_C1_${Id}`] = yupFormSchemas.string("อื่นๆ", { required: false });
        setschema(schema);
        form.trigger();

    }

    const onDeleteSLAComplaint1 = (itemRow) => {
        let indxRow = DataRowComplaint1.findIndex(f => f.nRow == itemRow.nRow);
        if (indxRow != -1) {
            DataRowComplaint1[indxRow].isDelete = true;
            form.setValue(`sDay_C1_${itemRow.nRow}`, null)
            form.setValue(`sToEmail_C1_${itemRow.nRow}`, null)
            form.setValue(`sInputEmail_C1_${itemRow.nRow}`, null)
            schema[`sDay_C1_${itemRow.nRow}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: false });
            schema[`sToEmail_C1_${itemRow.nRow}`] = yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: false });
            schema[`sInputEmail_C1_${itemRow.nRow}`] = yupFormSchemas.string("อื่นๆ", { required: false });
            setschema(schema);
            form.trigger();
        }
        let NewData = DataRowComplaint1.filter(f => f.isDelete != true);
        if (NewData.length > 0) {
            let nAccu = 0;
            NewData.forEach(element => {
                let nDay = element.sDay != null && element.sDay != "" ? parseInt(element.sDay) : 0;
                nAccu += nDay;
                element.nDayAccumulate = nAccu;
            });
        }
        setDataRowComplaint1(NewData || [])
    }

    //#endregion

    //#region  ข้อมูล SLA (ข้อร้องเรียนปกติ)

    const onAddSLAComplaint2 = () => {
        let dataForm = form.getValues();
        let arrComplaint2 = [];
        (DataRowComplaint2 || []).forEach(val => arrComplaint2.push(Object.assign({}, val)));
        let Id = arrComplaint2.length > 0 ? (Math.max.apply(Math, arrComplaint2.map(function (o) { return o.nRow; }))) + 1 : 1

        arrComplaint2.push({
            nID: Id,
            nRow: Id,
            sDay: null,
            nDayAccumulate: null,
            arrToEmail: [],
            sInputToEmail: null,
            isDelete: false,
            isNew: true,
        })

        setDataRowComplaint2(arrComplaint2)
        schema[`sDay_C2_${Id}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: true });
        schema[`sToEmail_C2_${Id}`] = yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: true });
        schema[`sInputEmail_C2_${Id}`] = yupFormSchemas.string("อื่นๆ", { required: false });
        setschema(schema);
        form.trigger();
    }

    const onDeleteSLAComplaint2 = (itemRow) => {
        let indxRow = DataRowComplaint2.findIndex(f => f.nRow == itemRow.nRow);
        if (indxRow != -1) {
            DataRowComplaint2[indxRow].isDelete = true;
            form.setValue(`sDay_C2_${itemRow.nRow}`, null)
            form.setValue(`sToEmail_C2_${itemRow.nRow}`, null)
            form.setValue(`sInputEmail_C2_${itemRow.nRow}`, null)
            schema[`sDay_C2_${itemRow.nRow}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: false });
            schema[`sToEmail_C2_${itemRow.nRow}`] = yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: false });
            schema[`sInputEmail_C2_${itemRow.nRow}`] = yupFormSchemas.string("อื่นๆ", { required: false });
            setschema(schema);
            form.trigger();
        }
        let NewData = DataRowComplaint2.filter(f => f.isDelete != true);
        if (NewData.length > 0) {
            let nAccu = 0;
            NewData.forEach(element => {
                let nDay = element.sDay != null && element.sDay != "" ? parseInt(element.sDay) : 0;
                nAccu += nDay;
                element.nDayAccumulate = nAccu;
            });
        }
        setDataRowComplaint2(NewData || [])
    }

    //#endregion

      //#region  ข้อมูล SLA (ข้อร้องขอ)
      const onAddSLARequest = () => {
        let dataForm = form.getValues();
        let arrRequest = [];
        (DataRowRequest || []).forEach(val => arrRequest.push(Object.assign({}, val)));
        let Id = arrRequest.length > 0 ? (Math.max.apply(Math, arrRequest.map(function (o) { return o.nRow; }))) + 1 : 1

        arrRequest.push({
            nID: Id,
            nRow: Id,
            sDay: null,
            nDayAccumulate: null,
            arrToEmail: [],
            sInputToEmail: null,
            isDelete: false,
            isNew: true,
        })

        setDataRowRequest(arrRequest)
        schema[`sDay_R_${Id}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: true });
        schema[`sToEmail_R_${Id}`] = yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: true });
        schema[`sInputEmail_R_${Id}`] = yupFormSchemas.string("อื่นๆ", { required: false });
        setschema(schema);
        form.trigger();
    }

    const onDeleteSLARequest = (itemRow) => {
        let indxRow = DataRowRequest.findIndex(f => f.nRow == itemRow.nRow);
        if (indxRow != -1) {
            DataRowRequest[indxRow].isDelete = true;
            form.setValue(`sDay_R_${itemRow.nRow}`, null)
            form.setValue(`sToEmail_R_${itemRow.nRow}`, null)
            form.setValue(`sInputEmail_R_${itemRow.nRow}`, null)
            schema[`sDay_R_${itemRow.nRow}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: false });
            schema[`sToEmail_R_${itemRow.nRow}`] = yupFormSchemas.stringArray("ผู้รับอีเมลแจ้งเตือน", { required: false });
            schema[`sInputEmail_R_${itemRow.nRow}`] = yupFormSchemas.string("อื่นๆ", { required: false });
            setschema(schema);
            form.trigger();
        }
        let NewData = DataRowRequest.filter(f => f.isDelete != true);
        if (NewData.length > 0) {
            let nAccu = 0;
            NewData.forEach(element => {
                let nDay = element.sDay != null && element.sDay != "" ? parseInt(element.sDay) : 0;
                nAccu += nDay;
                element.nDayAccumulate = nAccu;
            });
        }
        setDataRowRequest(NewData || [])
    }
  
    //#endregion

    //#region  ข้อมูล SLA (แจ้งความก้าวหน้า)

    const onAddSLAInform = () => {
        let dataForm = form.getValues();
        let arrInform = [];
        (DataRowInform || []).forEach(val => arrInform.push(Object.assign({}, val)));
        let Id = arrInform.length > 0 ? (Math.max.apply(Math, arrInform.map(function (o) { return o.nRow; }))) + 1 : 1

        arrInform.push({
            nID: Id,
            nRow: Id,
            sDay: null,
            nDayAccumulate: null,
            arrToEmail: [],
            sInputToEmail: null,
            isDelete: false,
            isNew: true,
        })

        setDataRowInform(arrInform)
        schema[`sDay_I_${Id}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: true });
        setschema(schema);
        form.trigger();

    }

    const onDeleteSLAInform = (itemRow) => {
        let indxRow = DataRowInform.findIndex(f => f.nRow == itemRow.nRow);
        if (indxRow != -1) {
            DataRowInform[indxRow].isDelete = true;
            form.setValue(`sDay_I_${itemRow.nRow}`, null)
            schema[`sDay_I_${itemRow.nRow}`] = yupFormSchemas.integer("จำนวนน้อยที่สุด 1 วัน", { required: false });
            setschema(schema);
            form.trigger();
        }
        let NewData = DataRowInform.filter(f => f.isDelete != true);
        if (NewData.length > 0) {
            let nAccu = 0;
            NewData.forEach(element => {
                let nDay = element.sDay != null && element.sDay != "" ? parseInt(element.sDay) : 0;
                nAccu += nDay;
                element.nDayAccumulate = nAccu;
            });
        }
        setDataRowInform(NewData || [])
    }

    //#endregion

    const onSubmitSLA = () => {
        SwAlert.Confirm(AlertTitleTh.Confirm, "คุณต้องการที่จะบันทึกใช่หรือไม่ ?", () => {
            let param = {
                IsCheckAlertComplaint1 : IsCheckAlertComplaint1,
                IsCheckAlertComplaint2 : IsCheckAlertComplaint2,
                IsCheckAlertRequest : IsCheckAlertRequest,
                IsCheckAlertInform : IsCheckAlertInform,
                lstComplain1 : DataRowComplaint1,
                lstComplain2 : DataRowComplaint2,
                lstRequest : DataRowRequest,
                lstInformProgress : DataRowInform,
            }
            BlockUI();
            AxiosPost(`SLAManage/onSaveSLA`, param, (res) => {
                UnBlockUI();

                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("บันทึกข้อมูลสำเร็จ")
                        setsSeveritySnackbar("success")
                        BlockUI();
                        setTimeout(() => {
                            UnBlockUI();
                        }, 2000)
                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();

                    }
                })
            }, null, null)
        })
    }

    const GetDataPageSLA = ()=>{
        BlockUI();
        AxiosGet(`SLAManage/GetDataPageSLA`, { }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {

                setsLastAction(res.sLastAction)

                setDataRowComplaint1(res.lstComplain1)
                setIsCheckAlertComplaint1(res.IsCheckAlertComplaint1)

                setDataRowComplaint2(res.lstComplain2)
                setIsCheckAlertComplaint2(res.IsCheckAlertComplaint2)

                setDataRowRequest(res.lstRequest)
                setIsCheckAlertRequest(res.IsCheckAlertRequest)

                setDataRowInform(res.lstInformProgress)
                setIsCheckAlertInform(res.IsCheckAlertInform)
            })
        });
    }


    
    
    return (
        <>
            <InnerHeadRoutes
                iconMUI={<ManageAccountsIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="ผู้ดูแลระบบ"
                label_nameRoute="จัดการข้อมูล SLA"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '0' }}>
                <Grid item xs={12}>
                    <Accordion header={"ข้อมูล SLA สำหรับภายใน (ข้อร้องเรียนที่มีนัยสำคัญ)"}>
                        <FormProvider {...form}>
                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center" >
                                <Grid item xs={12}>
                                    <TableContainer className='cus-table'>
                                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center" style={{ width: '9%', padding: '0 16px' }}>แจ้งเตือนครั้งที่</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '14%', padding: '0 16px' }}>จำนวนวัน</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '13%', padding: '0 16px' }}>จำนวนวันที่ครบกำหนด</StyledTableCell>
                                                    <StyledTableCell align="center">ผู้รับอีเมลแจ้งเตือน</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '7%', padding: '0 16px' }}></StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    DataRowComplaint1 != null && DataRowComplaint1.length > 0
                                                        ?
                                                        <>
                                                            {
                                                                DataRowComplaint1.map((row, idx) => (
                                                                    <StyledTableRow key={idx}>
                                                                        <StyledTableCell align="center">{idx + 1}</StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" >
                                                                                    <Grid item xs={12}>
                                                                                        <InputNumberFormItem
                                                                                            name={`sDay_C1_${row.nRow}`}
                                                                                            label=''
                                                                                            required={false}
                                                                                            integerDigits={3}
                                                                                            digits={0}
                                                                                            allowMinus={false}
                                                                                            IsAllowZero={false}
                                                                                            textAlign={"right"}
                                                                                            onChange={(e) => {
                                                                                                row.sDay = e?.target?.value
                                                                                            }}
                                                                                            onBlur={() => {
                                                                                                setIsCalComplaint1(!IsCalComplaint1)
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                </Grid>

                                                                            </>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center">{row.nDayAccumulate}</StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" >
                                                                                    <Grid item xs={12} sm={6}>
                                                                                        <CheckBoxGroupFormItem
                                                                                            name={`sToEmail_C1_${row.nRow}`}
                                                                                            options={
                                                                                                [
                                                                                                    { value: '1', label: "ผจ.ฝ่าย" },
                                                                                                    { value: '2', label: "ผช." },
                                                                                                    { value: '3', label: "อื่นๆ" },
                                                                                                ]
                                                                                            }
                                                                                            onChange={(Value) => {
                                                                                                row.arrToEmail = Value;
                                                                                                
                                                                                                schema[`sInputEmail_C1_${row.nRow}`] = yupFormSchemas.string("อื่นๆ", { required: Value.includes("3") ? true : false });
                                                                                                setschema(schema);
                                                                                                form.clearErrors();
                                                                                                // form.trigger();
                                                                                                if(!Value.includes("3"))
                                                                                                {
                                                                                                    form.setValue(`sInputEmail_C1_${row.nRow}`,null)
                                                                                                    row.sInputToEmail = "";
                                                                                                }
                                                                                               
                                                                                            }}

                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid item xs={12} sm={6}>
                                                                                        <InputCustomLabel
                                                                                            name={`sInputEmail_C1_${row.nRow}`}
                                                                                            label=""
                                                                                            required={false}
                                                                                            fullWidth
                                                                                            maxLength={1000}
                                                                                            disabled ={ (row.arrToEmail || []).includes("3") ? false : true}
                                                                                            onChange={(value) => {
                                                                                                row.sInputToEmail = value;

                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                </Grid>

                                                                            </>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <BtnDelete
                                                                                    isCircleWithOutText={true}
                                                                                    onClick={() => { onDeleteSLAComplaint1(row) }}
                                                                                />
                                                                            </>
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                        </>
                                                        :
                                                        <>
                                                            <StyledTableRow key={"r-sla-no-data"} >
                                                                <StyledTableCell align="center" colSpan={5}>ไม่พบข้อมูล</StyledTableCell>
                                                            </StyledTableRow>
                                                        </>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12}>
                                    <BtnAdd txt='เพิ่ม' onClick={form.handleSubmit(() => { onAddSLAComplaint1() })} />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={IsCheckAlertComplaint1}
                                                onChange={() => {
                                                    setIsCheckAlertComplaint1(!IsCheckAlertComplaint1);
                                                }}
                                            />
                                        }
                                        label="แจ้งเตือนตลอดไป ตามจำนวนวันที่ของครั้งสุดท้าย"
                                        labelPlacement="end"
                                    />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Accordion header={"ข้อมูล SLA สำหรับภายใน (ข้อร้องเรียนปกติ)"}>
                        <FormProvider {...form}>
                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center" >
                                <Grid item xs={12}>
                                    <TableContainer className='cus-table'>
                                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center" style={{ width: '9%', padding: '0 16px' }}>แจ้งเตือนครั้งที่</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '14%', padding: '0 16px' }}>จำนวนวัน</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '13%', padding: '0 16px' }}>จำนวนวันที่ครบกำหนด</StyledTableCell>
                                                    <StyledTableCell align="center">ผู้รับอีเมลแจ้งเตือน</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '7%', padding: '0 16px' }}></StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    DataRowComplaint2 != null && DataRowComplaint2.length > 0
                                                        ?
                                                        <>
                                                            {
                                                                DataRowComplaint2.map((row, idx) => (
                                                                    <StyledTableRow key={idx}>
                                                                        <StyledTableCell align="center">{idx + 1}</StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" >
                                                                                    <Grid item xs={12}>
                                                                                        <InputNumberFormItem
                                                                                            name={`sDay_C2_${row.nRow}`}
                                                                                            label=''
                                                                                            required={false}
                                                                                            integerDigits={3}
                                                                                            digits={0}
                                                                                            allowMinus={false}
                                                                                            IsAllowZero={false}
                                                                                            textAlign={"right"}
                                                                                            onChange={(e) => {
                                                                                                row.sDay = e?.target?.value
                                                                                            }}
                                                                                            onBlur={() => {
                                                                                                setIsCalComplaint2(!IsCalComplaint2)
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                </Grid>

                                                                            </>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center">{row.nDayAccumulate}</StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" >
                                                                                    <Grid item xs={12} sm={6}>
                                                                                        <CheckBoxGroupFormItem
                                                                                            name={`sToEmail_C2_${row.nRow}`}
                                                                                            options={
                                                                                                [
                                                                                                    { value: '1', label: "ผจ.ฝ่าย" },
                                                                                                    { value: '2', label: "ผช." },
                                                                                                    { value: '3', label: "อื่นๆ" },
                                                                                                ]
                                                                                            }
                                                                                            onChange={(Value) => {
                                                                                                row.arrToEmail = Value;

                                                                                                schema[`sInputEmail_C2_${row.nRow}`] = yupFormSchemas.string("อื่นๆ", { required: Value.includes("3") ? true : false });
                                                                                                setschema(schema);
                                                                                                form.clearErrors();

                                                                                                if(!Value.includes("3"))
                                                                                                {
                                                                                                    form.setValue(`sInputEmail_C2_${row.nRow}`,null)
                                                                                                    row.sInputToEmail = "";
                                                                                                }
                                                                                            }}

                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid item xs={12} sm={6}>
                                                                                        <InputCustomLabel
                                                                                            name={`sInputEmail_C2_${row.nRow}`}
                                                                                            label=""
                                                                                            required={false}
                                                                                            maxLength={1000}
                                                                                            fullWidth
                                                                                            disabled ={ (row.arrToEmail || []).includes("3") ? false : true}
                                                                                            onChange={(value) => {
                                                                                                row.sInputToEmail = value;
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <BtnDelete
                                                                                    isCircleWithOutText={true}
                                                                                    onClick={() => { onDeleteSLAComplaint2(row) }}
                                                                                />
                                                                            </>
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                        </>
                                                        :
                                                        <>
                                                            <StyledTableRow key={"r-sla-no-data"} >
                                                                <StyledTableCell align="center" colSpan={5}>ไม่พบข้อมูล</StyledTableCell>
                                                            </StyledTableRow>
                                                        </>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12}>
                                    <BtnAdd txt='เพิ่ม' onClick={form.handleSubmit(() => { onAddSLAComplaint2() })} />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={IsCheckAlertComplaint2}
                                                onChange={() => {
                                                    setIsCheckAlertComplaint2(!IsCheckAlertComplaint2);
                                                }}
                                            />
                                        }
                                        label="แจ้งเตือนตลอดไป ตามจำนวนวันที่ของครั้งสุดท้าย"
                                        labelPlacement="end"
                                    />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Accordion header={"ข้อมูล SLA สำหรับภายใน (ข้อร้องขอ)"}>
                        <FormProvider {...form}>
                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center" >
                                <Grid item xs={12}>
                                    <TableContainer className='cus-table'>
                                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center" style={{ width: '9%', padding: '0 16px' }}>แจ้งเตือนครั้งที่</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '14%', padding: '0 16px' }}>จำนวนวัน</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '13%', padding: '0 16px' }}>จำนวนวันที่ครบกำหนด</StyledTableCell>
                                                    <StyledTableCell align="center">ผู้รับอีเมลแจ้งเตือน</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '7%', padding: '0 16px' }}></StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    DataRowRequest != null && DataRowRequest.length > 0
                                                        ?
                                                        <>
                                                            {
                                                                DataRowRequest.map((row, idx) => (
                                                                    <StyledTableRow key={idx}>
                                                                        <StyledTableCell align="center">{idx + 1}</StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" >
                                                                                    <Grid item xs={12}>
                                                                                        <InputNumberFormItem
                                                                                            name={`sDay_R_${row.nRow}`}
                                                                                            label=''
                                                                                            required={false}
                                                                                            integerDigits={3}
                                                                                            digits={0}
                                                                                            allowMinus={false}
                                                                                            IsAllowZero={false}
                                                                                            textAlign={"right"}
                                                                                            onChange={(e) => {
                                                                                                row.sDay = e?.target?.value
                                                                                            }}
                                                                                            onBlur={() => {
                                                                                                setIsCalRequest(!IsCalRequest)
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                </Grid>

                                                                            </>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center">{row.nDayAccumulate}</StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" >
                                                                                    <Grid item xs={12} sm={6}>
                                                                                        <CheckBoxGroupFormItem
                                                                                            name={`sToEmail_R_${row.nRow}`}
                                                                                            options={
                                                                                                [
                                                                                                    { value: '1', label: "ผจ.ฝ่าย" },
                                                                                                    { value: '2', label: "ผช." },
                                                                                                    { value: '3', label: "อื่นๆ" },
                                                                                                ]
                                                                                            }
                                                                                            onChange={(Value) => {
                                                                                                row.arrToEmail = Value;

                                                                                                schema[`sInputEmail_R_${row.nRow}`] = yupFormSchemas.string("อื่นๆ", { required: Value.includes("3") ? true : false });
                                                                                                setschema(schema);
                                                                                                form.clearErrors();

                                                                                                if(!Value.includes("3"))
                                                                                                {
                                                                                                    form.setValue(`sInputEmail_R_${row.nRow}`,null)
                                                                                                    row.sInputToEmail = "";
                                                                                                }
                                                                                            }}

                                                                                        />
                                                                                    </Grid>
                                                                                    <Grid item xs={12} sm={6}>
                                                                                        <InputCustomLabel
                                                                                            name={`sInputEmail_R_${row.nRow}`}
                                                                                            label=""
                                                                                            required={false}
                                                                                            maxLength={1000}
                                                                                            fullWidth
                                                                                            disabled ={ (row.arrToEmail || []).includes("3") ? false : true}
                                                                                            onChange={(value) => {
                                                                                                row.sInputToEmail = value;
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <BtnDelete
                                                                                    isCircleWithOutText={true}
                                                                                    onClick={() => { onDeleteSLARequest(row) }}
                                                                                />
                                                                            </>
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                        </>
                                                        :
                                                        <>
                                                            <StyledTableRow key={"r-sla-no-data"} >
                                                                <StyledTableCell align="center" colSpan={5}>ไม่พบข้อมูล</StyledTableCell>
                                                            </StyledTableRow>
                                                        </>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12}>
                                    <BtnAdd txt='เพิ่ม' onClick={form.handleSubmit(() => { onAddSLARequest() })} />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={IsCheckAlertRequest}
                                                onChange={() => {
                                                    setIsCheckAlertRequest(!IsCheckAlertRequest);
                                                }}
                                            />
                                        }
                                        label="แจ้งเตือนตลอดไป ตามจำนวนวันที่ของครั้งสุดท้าย"
                                        labelPlacement="end"
                                    />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Accordion header={"ข้อมูล SLA สำหรับภายนอก (แจ้งความก้าวหน้า)"}>
                        <FormProvider {...form}>
                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center" >
                                <Grid item xs={12} md={6}>
                                    <TableContainer className='cus-table'>
                                        <Table aria-label="customized table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center" style={{ width: '20%', padding: '16px' }}>แจ้งเตือนครั้งที่</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '35%', padding: '16px' }}>จำนวนวัน</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '35%', padding: '6px' }}>จำนวนวันที่ครบกำหนด</StyledTableCell>
                                                    <StyledTableCell align="center" style={{ width: '10%', padding: '16px' }}></StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    DataRowInform != null && DataRowInform.length > 0
                                                        ?
                                                        <>
                                                            {
                                                                DataRowInform.map((row, idx) => (
                                                                    <StyledTableRow key={idx}>
                                                                        <StyledTableCell align="center">{idx + 1}</StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <Grid container spacing={1} direction="row" justifyContent="start" alignItems="center" >
                                                                                    <Grid item xs={12}>
                                                                                        <InputNumberFormItem
                                                                                            name={`sDay_I_${row.nRow}`}
                                                                                            label=''
                                                                                            required={false}
                                                                                            integerDigits={3}
                                                                                            digits={0}
                                                                                            allowMinus={false}
                                                                                            IsAllowZero={false}

                                                                                            textAlign={"right"}
                                                                                            onChange={(e) => {
                                                                                                row.sDay = e?.target?.value
                                                                                            }}
                                                                                            onBlur={() => {
                                                                                                setIsCalProgress(!IsCalProgress)
                                                                                            }}
                                                                                        />
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </>
                                                                        </StyledTableCell>
                                                                        <StyledTableCell align="center">{row.nDayAccumulate}</StyledTableCell>
                                                                        <StyledTableCell align="center">
                                                                            <>
                                                                                <BtnDelete
                                                                                    isCircleWithOutText={true}
                                                                                    onClick={() => { onDeleteSLAInform(row) }}
                                                                                />
                                                                            </>
                                                                        </StyledTableCell>
                                                                    </StyledTableRow>
                                                                ))}
                                                        </>
                                                        :
                                                        <>
                                                            <StyledTableRow key={"r-sla-no-data"} >
                                                                <StyledTableCell align="center" colSpan={4}>ไม่พบข้อมูล</StyledTableCell>
                                                            </StyledTableRow>
                                                        </>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12}>
                                    <BtnAdd txt='เพิ่ม' onClick={form.handleSubmit(() => { onAddSLAInform() })} />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={IsCheckAlertInform}
                                                onChange={() => {
                                                    setIsCheckAlertInform(!IsCheckAlertInform);
                                                }}
                                            />
                                        }
                                        label="แจ้งเตือนตลอดไป ตามจำนวนวันที่ของครั้งสุดท้าย"
                                        labelPlacement="end"
                                    />
                                </Grid>
                            </Grid>
                        </FormProvider>
                    </Accordion>
                </Grid>
                {
                    sLastAction != "-" && sLastAction != null
                        ?
                        <Grid item xs={12}>
                            <Accordion header={"ผู้แก้ไขข้อมูลล่าสุด"}>
                                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center" >
                                    <Grid item xs={12}>
                                        {sLastAction}
                                    </Grid>
                                </Grid>
                            </Accordion>
                        </Grid>
                        : null
                }
                <Grid item >
                    <BtnConfirm txt='บันทึก' onClick={form.handleSubmit(() => { onSubmitSLA() })} />
                </Grid>
            </Grid>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default SLAManage